import { Dispatch, SetStateAction, memo } from 'react';
import { Grid } from '@mantine/core';
import { type MRT_PaginationState, type MRT_SortingState } from 'mantine-react-table';
import { useTranslation } from 'react-i18next';
import { formatMoneyString, getCustomerFullName } from '../../../utils/strings';
import Table from '../../../components/Table';
import { CustomersReportTableInfoData } from '.';
import moment from 'moment';

export default memo(function TableView({
  tableInfoData = [],
  totalRowsCount = 0,
  pages = 0,
  isError = false,
  isLoading = false,
  pagination,
  setPagination,
  sorting,
  setSorting
}: {
  tableInfoData: CustomersReportTableInfoData[];
  totalRowsCount: any;
  pages: any;
  isError: boolean;
  isLoading: boolean;
  pagination: MRT_PaginationState;
  setPagination: Dispatch<SetStateAction<MRT_PaginationState>>;
  sorting: MRT_SortingState;
  setSorting: Dispatch<SetStateAction<MRT_SortingState>>;
}) {
  const { t } = useTranslation(['FieldName']);

  const columns = [
    {
      id: 'customerName',
      accessorFn: (row) => getCustomerFullName(row._id.name, row._id.lastName),
      header: t('FieldName:customer'),
      enableSorting: false
    },
    {
      id: 'lastOrderDate',
      accessorFn: (row) => row.lastOrderDate ? moment(row.lastOrderDate).format('DD/MM/YYYY') : '-',
      header: t('FieldName:lastOrderDate'),
      enableSorting: true
    },
    {
      id: 'ordersQty',
      accessorFn: (row) => row.ordersQty,
      header: t('FieldName:orders'),
      enableSorting: true
    },
    {
      id: 'ordersSalesTotal',
      accessorFn: (row) => formatMoneyString((row.ordersSalesTotal || 0).toFixed(2)),
      header: t('FieldName:total'),
      enableSorting: true
    },
    {
      id: 'ordersUnpaidTotal',
      accessorFn: (row) => formatMoneyString((row.ordersUnpaidTotal || 0).toFixed(2)),
      header: t('FieldName:amountDue'),
      enableSorting: false
    }
  ];

  return (
    <>
      <Grid gutter="md">
        <Grid.Col span={12}>
          <Table
            tableColumns={columns}
            pagination={pagination}
            setPagination={setPagination}
            tableData={tableInfoData}
            isError={isError}
            paginationIsLoading={isLoading}
            numPages={pages}
            totalRowsCount={totalRowsCount}
            overrideTableConfigs={{
              manualPagination: false,
              enableSorting: true,
              enableMultiSort: false,
              state: { sorting },
              onSortingChange: setSorting
            }}
          />
        </Grid.Col>
      </Grid>
    </>
  );
});
